export default {
    key: 'joch',
    type: 'P2P',
    isUsingProductConfigPresets: false,
    isUsingProductPresets: true,
    hideCrossSells: false,
    disablePassengers: false,
    origins: [],
    destinations: [{
        ref: 'urn:uic:stn:8507364',
        name: 'Jungfraujoch – Top of Europe',
    }],
    returnOrigins: [],
    returnDestinations: [],
    isRoundtrip: true,
    canSwitchDirection: false,
    canChooseReturnDestination: false,
    isUsingReductionCards: true,
    isUsingKeyCards: false,
    isUsingPromos: true,
    isPromotionRequired: false,
    hasEPR: true,
    routeVariants: ['express', 'traditional-grin', 'traditional-laut'],
    routeVariantUp: 'default-jungfraujoch',
    routeVariantDown: 'default-jungfraujoch',
    upsells: [],
    isUsingSeasonDates: false,
    departureTimeIteration: 30,
    departureTimeDefaultMin: 420,
    stayDurationIteration: 30,
    stayDurationPopular: 120,
    stayDurationMin: 30,
    maxNumberOfPeople: 9,
    maxNumberOfPeopleGroupTariff: 10,
    salesTimeLimit: undefined,
    isUpsellDatesRestricted: true,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: undefined,
    listingId: 'urn:listing:trips:joch',
    isLocalListing: true,
    steps: [
        {
            routeName: 'offerFlow-joch-steps-step-1-date',
            name: 'offerFlow.pages.stepDate.name.common',
        },
        {
            routeName: 'offerFlow-joch-steps-step-3-trip-selection',
            name: 'offerFlow.pages.stepTripSelection.name.common',
        },
        {
            routeName: 'offerFlow-joch-steps-step-5-passengers',
            name: 'offerFlow.pages.stepPassengers.name.common',
            skipIfUpsell: true,
        },
    ],

} satisfies ProductConfigP2P;
